import { camelCase, get } from 'lodash';

import { useQuery } from '@apollo/react-hooks';

import switchesQuery from './switchesQuery';

/**
 * Hook to query switches for the current user, regardless
 * of whether they're logged in or not.
 */
const useSwitch = (switchName: string) => {
  const result = useQuery(switchesQuery, {
    ssr: false,
    // Refetch from network in case user changes from logged
    // out to logged in, which can affect their switches.
    fetchPolicy: 'cache-and-network',
  });
  const isSwitchOn = get(
    result,
    ['data', 'session', 'switches', camelCase(switchName)],
    false
  );

  return {
    isLoading: result.loading,
    isSwitchOn,
  };
};

export default useSwitch;
